import axios from 'axios'
import router from '../router'
import { createStore } from 'vuex'

export default createStore({
	state: {
		versionNumber: '0.3.210928',
		searchTerm: '',
		pluginsFilter: {
			categories:		[],
			technologies:	[],
			creators: 		[],
			rating: 		[],
			downloads:		[],
			custom:			[],
			certified:		[]
		},
		currentFilteredPlugins: null,
		currentFilters: {
			categories:	{
				label: '',
				value: '',
				entries: {},
			},
			technologies:	{
				label: '',
				value: '',
				entries: {},
			},
			creators:	{
				label: '',
				value: '',
				entries: {},
			},
			rating:	{
				label: '',
				value: '',
				entries: {},
			},
			downloads:	{
				label: '',
				value: '',
				entries: {},
			},
			custom: {
				label: '',
				value: '',
				entries: {},
			},
			certified: {
				label: '',
				value: '',
				entries: {},
			},
		},
		clear_text_technologies: {
			'4': 'ir',
			'5': 'rsr232',
			'6': 'rs485',
			'7': 'modbus',
			'11': 'network',
			'17': 'air',
			'19': 'air_tree',
			'999': 'other',
		},
		clear_text_categories: {
			'1': 'shading',
			'2': 'multimedia',
			'3': 'lighting',
			'6': 'security',
			'7': 'energy',
			'8': 'sensor',
			'10': 'weather',
			'11': 'climate',
			'12': 'access',
			'15': 'irrigation',
			'16': 'wellness',
			'18': 'controls',
			'19': 'wallbox',
			'20': 'inverter',
			'21': 'battery',
			'999': 'other',
		},
		clear_text_certified: {
			'1': 'certified',
		},
		clear_text_creator: {
			'1': 'loxone',
			'2': 'vendor',
			'3': 'community'
		},
		loggedIn: false,
		userData: null,
		loginErrorMessage: '',
		creatorPage: false,
		startPage: true,
		mobileFilterVisible: false,
		rating: {
			label: 'Ratings',
			value: 'rating',
			entries: {
			a:	{
					label: '& more',
					id: 4,
					name: 4
				},
			b:	{
					label: '& more',
					id: 3,
					name: 3,
				},
			c:	{
					label: '& more',
					id: 2,
					name: 2,
				},
			d:	{
					label: '& more',
					id: 2,
					name: 1,
				}
			}
		},
		downloads: {
			label: 'Downloads',
			value: 'downloads',
			entries: {
				a:	{
					label: '250+ downloads',
					name: 250,
					id: 250,
					selected: false,
				},
				b:	{
					label: '100+ downloads',
					name: 100,
					id: 100,
					selected: false,
				},
				c:	{
					label: '50+ downloads',
					name: 50,
					id: 50,
					selected: false,
				},
				d:	{
					label: '10+ downloads',
					name: 10,
					id: 10,
					selected: false,
				}
			}
		},
		notifications: [],
		cancelSource: null,
		infoText: null
	},

	mutations: {
	},

	actions: {

		login({commit}, user){
			var userData = new FormData();
			userData.append('email_address', user.email_address);
			userData.append('password', user.password);
			axios({
				method: 'post',
				crossDomain: true,
				withCredentials: true,
				url: 'https://api.library.loxone.com/login',
				data: userData
			})
			.then(resp => {
				this.state.searchTerm = '';
				this.state.pluginsFilter.technologies = [];
				this.state.pluginsFilter.categories = [];
				this.state.pluginsFilter.creators = [];
				this.state.pluginsFilter.rating = [];
				this.state.pluginsFilter.downloads = [];
				this.state.pluginsFilter.custom = [];
				this.state.pluginsFilter.certified = [];
				this.state.loginErrorMessage = '';
				if (resp.data && resp.data.valid) {
					this.state.loggedIn = resp.data.valid;
					if (resp.data.userData) {
						this.state.userData = resp.data.userData;
					}
					router.push('/');
				}

				if(resp.data && resp.data.error_code) {
					this.state.loginErrorMessage = resp.data.error_code;
				}


			})
		},

		logout(){
			this.state.loggedIn = false;
			this.state.userData = '';
			axios({
				method: 'post',
				crossDomain: true,
				withCredentials: true,
				url: 'https://api.library.loxone.com/logout'
			})
			.then(() => {
				this.state.loggedIn = false;
				this.state.userData = null;
				router.push('/');

			});
		},

		loadFilteredPlugins({commit}, additionalFilters = '') {
			
			this.state.currentFilteredPlugins = null;
			this.state.infoText = 'please wait 5 seconds to load data';

			this.dispatch('cancelSearch');

			this.state.cancelSource = axios.CancelToken.source();

			var filteredPlugins = new FormData();
			var filter = this.state.pluginsFilter
			
			let currentQuery = {};

			//ADD SERACH TERM TO URL;
			if(this.state.searchTerm) {
				currentQuery['s'] = decodeURIComponent(this.state.searchTerm.replace(/\+/g, '%20'));
			}
			
			//ADD TECHNOLOGIES TO URL
			if(filter.technologies.length > 0) {

				let tmp_technologies = this.state.clear_text_technologies;
				let filter_technologies = [];
				filter.technologies.forEach(function(technology) {
					filter_technologies.push(tmp_technologies[technology]);
				});

				currentQuery['t'] = filter_technologies.join(',');
			}

			if(filter.categories.length > 0) {
				let tmp_categories = this.state.clear_text_categories;
				let filter_categories = [];
				filter.categories.forEach(function(category) {
					filter_categories.push(tmp_categories[category]);
				});

				currentQuery['c'] = filter_categories.join(',');
			}

			if(filter.certified.length > 0) {
				let tmp_certifieds = this.state.clear_text_certified;
				let filter_certified = [];
				filter.certified.forEach(function(certified) {
					filter_certified.push(tmp_certifieds[certified]);
				});

				currentQuery['wwl'] = filter_certified.join(',');
			}

			if(filter.creators.length > 0) {
				let tmp_creators = this.state.clear_text_creator;
				let filter_creators = [];
				filter.creators.forEach(function(creator) {
					filter_creators.push(tmp_creators[creator]);
				});

				currentQuery['cr'] = filter_creators.join(',');
			}

			const routeConfig = {path: '/', query: currentQuery};

			router.push(routeConfig);



			if(additionalFilters != ""){
				filter = additionalFilters.filter;
			}
			filteredPlugins.append('filter', JSON.stringify(filter));
			if(additionalFilters.orderby == 'id_desc') {
				filteredPlugins.append('orderby', 'id');
				filteredPlugins.append('order', 'DESC');
			} else {
				filteredPlugins.append('orderby', 'plugin_displayname');
				filteredPlugins.append('order', 'ASC');
			}
			filteredPlugins.append('limit', '0,300');
			filteredPlugins.append('isFiltered', 'true');
			filteredPlugins.append('searchTerm', this.state.searchTerm);


			axios({
				method: 'post',
				crossDomain: true,
				withCredentials: true,
				url: 'https://api.library.loxone.com/loadFilteredPlugins',
				data: filteredPlugins,
				cancelToken: this.state.cancelSource.token
			})
			.then(response => {
				this.state.currentFilteredPlugins = response.data;
				this.state.infoText = null;
				this.state.cancelSource = null;
			}).catch(error => {
			});

		},

		cancelSearch() {
			if(this.state.cancelSource) {
				this.state.cancelSource.cancel();
			}
		},

		clearFilter(){
			this.state.pluginsFilter.technologies = [];
			this.state.pluginsFilter.categories = [];
			this.state.pluginsFilter.creators = [];
			this.state.pluginsFilter.rating = [];
			this.state.pluginsFilter.downloads = [];
			this.state.pluginsFilter.custom = [];
			this.state.pluginsFilter.certified = [];
			for (const [filter_key, filter_value] of Object.entries(this.state.currentFilters)) {
				if(filter_key != ''){
					for (const [key, value] of Object.entries(filter_value.entries)) {
						if(key != ''){
							value.selected = false;
						}
					}
				}
			}
		},

		toggleFilter({commit}, data){
			console.log(data);
			for (const [filter_key, filter_value] of Object.entries(this.state.currentFilters)) {
				if(filter_key == data.filterby){
					for (const [key, value] of Object.entries(filter_value.entries)) {
						if(key == data.filter){
							value.selected = !value.selected;
						}
					}
				}
			}
			switch(data.filterby){
				case 'rating':
					if(!data.isSelected){
						for (const [filter_key, filter_value] of Object.entries(this.state.rating.entries)) {
							if(filter_key != ''){
								filter_value.selected = false;
							}
						}
					}
					for (const [filter_key, filter_value] of Object.entries(this.state.rating.entries)) {
						if(filter_value.name == data.filter && filter_key != ''){
							filter_value.selected = true;
						}
					}
					break;
				case 'downloads':
					if(!data.data.isSelected){
						for (const [filter_key, filter_value] of Object.entries(this.state.downloads.entries)) {
							if(filter_key != ''){
								filter_value.selected = false;
							}
						}
					}
					for (const [filter_key, filter_value] of Object.entries(this.state.downloads.entries)) {
						if(filter_value.name == data.filter && filter_key != ''){
							filter_value.selected = true;
						}
					}
				break;
			}

			//Change Filter
			if(data.filterby == "technology") {
				if(data.isSelected) {
					this.state.pluginsFilter.technologies = this.state.pluginsFilter.technologies.filter(filterEntry => filterEntry != data.filter);
				}else{
					this.state.pluginsFilter.technologies.push(data.filter);
				}
			}
			if(data.filterby == "custom") {
				if(data.isSelected) {
					this.state.pluginsFilter.custom = this.state.pluginsFilter.custom.filter(filterEntry => filterEntry != data.filter);
				}else{
					this.state.pluginsFilter.custom.push(data.filter);
				}
			}
			if(data.filterby == "category") {
				if(data.isSelected) {
					this.state.pluginsFilter.categories = this.state.pluginsFilter.categories.filter(filterEntry => filterEntry != data.filter);
				}else{
					this.state.pluginsFilter.categories.push(data.filter);
				}
			}
			if(data.filterby == "creator") {
				if(data.isSelected) {
					this.state.pluginsFilter.creators = this.state.pluginsFilter.creators.filter(filterEntry => filterEntry != data.filter);
				}else{
					this.state.pluginsFilter.creators.push(data.filter);
				}
			}
			if(data.filterby == "rating") {
				this.state.pluginsFilter.rating = [];
				this.state.pluginsFilter.rating.push(data.filter);
			}
			if(data.filterby == "downloads") {
				this.state.pluginsFilter.downloads = [];
				this.state.pluginsFilter.downloads.push(data.filter);
			}
			if(data.filterby == "certified") {
				if(data.isSelected) {
					this.state.pluginsFilter.certified = this.state.pluginsFilter.certified.filter(filterEntry => filterEntry != data.filter);
				}else{
					this.state.pluginsFilter.certified.push(data.filter);
				}
			}
			
			this.dispatch('loadFilteredPlugins');
		},

		addNotification({commit}, data){
			var t = new Date();
			var e = new Date().setSeconds(t.getSeconds()+5);
			var timestamp = Math.round(+e/1000);
			this.state.notifications.push({
				'id':		timestamp,
				'title':	data.title,
				'text':		data.text,
				'type':		data.type,
				active:		true,
			});
		},

		checkNotifications(){
			if(this.state.notifications.length > 0){
				var timestamp = Math.round(+new Date()/1000);
				for (const [key, value] of Object.entries(this.state.notifications)){
					if(timestamp >= value.id){
						this.state.notifications[key].active = false;
					}
				}

			}
		},

		hideNotification({commit}, id){
			for (const [key, value] of Object.entries(this.state.notifications)){
				if(id == value.id) {
					this.state.notifications[key].active = false;
				}
			}
		},
	},

	modules: {
	},
})
